import React, { Component } from 'react';
import "./index.less";

class VirtualizedDatabase extends Component {
    constructor(props) {
        super(props);
        this.rowHeight = this.props.itemHeight;
        //this.buffer = this.props.buffer || 10;
        this.buffer = 0;
        this.start = 0;
        this.end = 0;
        this.wrapperRef = React.createRef();
        this.wrapperHeight = 0;
        this.scrollTop = 0;
        this.state = { renderData: [], scrollTop: 0 };
    }

    componentDidMount(){
        this.wrapperDom = this.wrapperRef.current; 
        this.wrapperHeight = this.wrapperDom.clientHeight;
        this.visibleLen = Math.ceil(this.wrapperHeight/this.rowHeight);
        this.renderCount = this.visibleLen;
        this.calcRender();

        this.wrapperDom.addEventListener('scroll', this.throttleScroll);
    }

    componentWillUnmount(){
        this.wrapperDom.removeEventListener('scroll', this.throttleScroll);
    }

    calcRender = () => {
        let { data } = this.props;
        this.end = this.start + this.renderCount;
        if(data.length <= this.end ){
            this.end = data.length;
            //this.start = this.end - this.renderCount;
            //this.scrollTop = this.end * this.rowHeight;
        }
        let renderData = data.slice(this.start, this.end);
        this.setState({ renderData, scrollTop: this.scrollTop });
        //判断剩余数据 与 start 和 end 的关系
    }

    throttleScroll = event =>{
        this.throttle(this.handleScroll.bind(this, event), 500)();
    }

    // 事件节流函数
    throttle = (fn, threshhold)=>{
        let last, deferTimer;
        threshhold || (threshhold = 250);
        return function () {
            let context = this, args = arguments, now = +new Date();
            if (last && now < last + threshhold) {
                // 如果足够的时间没有过去，则清除定时器并重新设置
                clearTimeout(deferTimer);
                deferTimer = setTimeout(function () {
                    last = now;
                    fn.apply(context, args);
                }, threshhold);
            } else {
                // 如果时间足够，执行函数并重置last
                last = now;
                fn.apply(context, args);
            }
        };
    }

    handleScroll = () =>{
        this.scrollTop = this.wrapperDom.scrollTop;
        this.start = Math.ceil(this.scrollTop/this.rowHeight);
        this.calcRender();
    }

    render(){
        let { renderItem, data, wrapperClassName } = this.props;
        let { renderData, scrollTop } = this.state;
        wrapperClassName = wrapperClassName + ' virtual-render-wrapper';
        
        return (
            <ul className={wrapperClassName} ref={ this.wrapperRef }>
                <div className="virtual-render-container" style={{ height: data.length * this.rowHeight }}></div>
                <div className="virtual-render-content" style={{ transform: 'translateY(' + scrollTop + 'px)' }}>
                    {renderData.map((eve, k) => {
                        return renderItem(eve, k);
                    })}
                </div>
            </ul>
        );
            
    }
}

export default VirtualizedDatabase;
